import type { QuickSuggestion, ContactCTA } from '@brochure/shared'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label (button text) and
 * message (the actual text sent to the assistant on click).
 *
 * Labels and messages are translated in both `it` and `en` locales —
 * see `chatbot.quickSuggestions.*` in `public/locales/{lang}/common.json`.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'inStock',
    labelKey: 'chatbot.quickSuggestions.inStock.label',
    messageKey: 'chatbot.quickSuggestions.inStock.message',
  },
  {
    id: 'favrettoService',
    labelKey: 'chatbot.quickSuggestions.favrettoService.label',
    messageKey: 'chatbot.quickSuggestions.favrettoService.message',
  },
  {
    id: 'quote',
    labelKey: 'chatbot.quickSuggestions.quote.label',
    messageKey: 'chatbot.quickSuggestions.quote.message',
  },
  {
    id: 'retrofit',
    labelKey: 'chatbot.quickSuggestions.retrofit.label',
    messageKey: 'chatbot.quickSuggestions.retrofit.message',
  },
  {
    id: 'location',
    labelKey: 'chatbot.quickSuggestions.location.label',
    messageKey: 'chatbot.quickSuggestions.location.message',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 *
 * - `copy`: click copies `value` to the clipboard (ideal for phone/email).
 * - `link`: opens `url` in a new tab (ideal for external contact channels).
 *
 * For Fenix Srl we expose the company phone, email, and a direct link to
 * the contacts page so users can open the full contact form.
 */
export const contactCTAs: ContactCTA[] = [
  {
    kind: 'copy',
    id: 'phone',
    labelKey: 'chatbot.contactCTAs.phone',
    value: '+39 011 9604036',
  },
  {
    kind: 'copy',
    id: 'email',
    labelKey: 'chatbot.contactCTAs.email',
    value: 'info@fenixgrind.it',
  },
]
